export default "__VITE_ASSET__CxRKlyLu__"